module.exports = __webpack_public_path__ + "img/Ellipse7.60bcf2bb.png";